import { useEffect, useRef } from 'react'
import { useParticipants } from '@/entities/call'
import { playNotifySound } from '@/shared/lib'
import { toast } from '@/shared/ui/toast'
import { useChatStore } from './chat-store'
import { useChatNotifySettings } from './notify-store'

const PREVIEW_MAX = 60

// Уведомление (тост по центру сверху + звук) о чужом сообщении чата.
// Сообщения, уже лежавшие в сторе на момент монтирования, — базлайн.
// Тумблер — useChatNotifySettings (управляется из окна чата).
export function useChatNotifications(): void {
  const messages = useChatStore((s) => s.messages)
  const participants = useParticipants()
  const enabled = useChatNotifySettings((s) => s.enabled)
  const seenRef = useRef<Set<string> | null>(null)

  useEffect(() => {
    if (seenRef.current === null) {
      seenRef.current = new Set(messages.map((m) => m.id))
      return
    }
    const seen = seenRef.current
    const fresh = messages.filter((m) => !seen.has(m.id))
    for (const m of messages) seen.add(m.id)
    const foreign = fresh.filter((m) => m.authorId !== 'local')
    if (foreign.length === 0 || !enabled) return
    for (const m of foreign) {
      const author = participants.find((p) => p.id === m.authorId)?.name ?? 'Участник'
      const preview = m.text.length > PREVIEW_MAX ? `${m.text.slice(0, PREVIEW_MAX)}…` : m.text
      toast.notify(`${author}: ${preview}`)
    }
    playNotifySound()
  }, [messages, participants, enabled])
}
